module.exports = __webpack_public_path__ + "img/google-play.8570b33.svg";